import React, { ReactNode, useState, useRef, useEffect } from 'react';
import cN from 'classnames';
import styles from './styles.module.scss';

interface I_Props {
    content: ReactNode;
    bubbleWidth?: number;
    children?: React.ReactNode;
}

const BubbleBox: React.FC<I_Props> = ({ children, content, bubbleWidth = 360 }) => {
    const bodyRef = useRef<HTMLDivElement>(null);
    const [containerLeft, setContainerLeft] = useState<number>(0);
    const [isActive, setIsActive] = useState<boolean>(false);

    useEffect(() => {
        const width = bodyRef!.current!.offsetWidth;
        setContainerLeft(width);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bodyRef?.current?.offsetWidth]);

    return (
        <span
            className={cN(styles.container, 'BubbleBox', { [`${styles.active}`]: isActive })}
            ref={bodyRef}
            onMouseLeave={() => setIsActive(false)}
            onMouseEnter={() => setIsActive(true)}
        >
            {children}
            <div
                className={styles.bubbleContent}
                style={{
                    width: bubbleWidth,
                    left: -(bubbleWidth / 2 - containerLeft / 2),
                }}
            >
                {content}
            </div>
        </span>
    );
};

export default BubbleBox;
